module.exports = __webpack_public_path__ + "static/media/seennews.af4898c2.webp";